import { SubNav, type SubNavItem } from "@lilbillbiscuit/account-ui"

const ITEMS: SubNavItem[] = [
  { to: "/admin", label: "Overview", end: true },
  { to: "/admin/videos", label: "Videos" },
  { to: "/admin/users", label: "Users" },
  { to: "/admin/tags", label: "Tags" },
  { to: "/admin/requests", label: "Requests" },
]

/** Pre-bound SubNav for glarchive's admin section. */
export function GlarchiveSubNav() {
  return <SubNav items={ITEMS} />
}
